module.exports = __webpack_public_path__ + "img/logo_p_pautions.f09f8d03.svg";